import { render, staticRenderFns } from "./modal-palestrantes.vue?vue&type=template&id=6bb9ff9e&"
import script from "./modal-palestrantes.vue?vue&type=script&lang=js&"
export * from "./modal-palestrantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports